<template>
  <el-row class="border-line">
    <el-col :span="4" style="display: flex;align-items: center;height: 120px;margin: 0 15px;justify-content: center;" class="cursor-pointer" >
    <!-- <el-col :sm="2" :md="2" :lg="1" :xl="4" style="display: flex;align-items: center;height: 120px;margin: 0 15px;justify-content: center;"> -->
      <img v-if="language === 'EN'" src="../assets/img/head/en_logo.jpg" alt="" @click="$router.push('/')"/>
      <img v-else src="../assets/img/head/logo.png" alt="" @click="$router.push('/')"/>
      <!-- <img src="../assets/img/head/logo1.png" alt="" @click="$router.push('/')"/>
      <div style="font-size: 0.28rem;line-height: 30px;padding-left:0.2rem;color: #393953;">
        <div style="letter-spacing: 0.088rem;">SEA HORSE</div>
        <div>海馬牌官方旗舰店</div>
      </div> -->
    </el-col>
    <!-- <div style="display: flex;flex-direction: column;">
      <el-col :span="18">
        <div style="height: 60px;background-color: #f2f2f2;border-radius: 0px 0px 0px 20px;font-size: 14px;" class="flex-center">
          <el-row >
            <el-col :offset="6">
              <a href="">
                <img src="../assets/img/head/cart.png" alt="">
                购物车
              </a>
            </el-col>
            <el-col :offset="6">
              <a href="">
                <img src="../assets/img/head/cart.png" alt="">
                购物车
              </a>
            </el-col>
            <el-col :span="8">
              <a href="">
                <img src="../assets/img/head/cart.png" alt="">
                购物车
              </a>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </div> -->
    <div style="display: flex;flex-direction: column;">
      <el-col :span="24">
        <div style="height: 60px;background-color: #f2f2f2;border-radius: 0px 0px 0px 20px;font-size: 0.14rem;"
          class="flex-center flex-sb">
          <!-- <ul class="flex">
            <li class="pl-3"><a href="" class="login">登入</a></li>
            <li class="pl-3"><a href="" class="nav">註冊</a></li>
            <li class="pl-3" v-for="(val,index) in navList" :key="index">
              <a href="" class="nav">
                <img :src="val.img" alt="" class="mr-1">
                {{val.name}}
              </a>
            </li>
          </ul> -->
          <div class="flex">
            <template v-if="info.id">
              <label for="" @click="$router.push('/account')" class="cursor-pointer">
                <img :src="info.headImg" alt="" class="ml-1 headImg" v-if="info.headImg"/>
                <img src="../assets/img/head/avatar.png" alt="" class="ml-1 headImg" v-else/>
                {{info.nickName}}
              </label>
              <label for="" class="pl-3" v-for="(val,index) in navList"  :key="index">
                <template v-if="info.id">
                  <a v-if="val.url === '/message'" :href="val.url" class="nav">
                    <img :src="val.img" alt="" class="mr-1">
                    <el-badge :value="$store.state.messageNum" class="item">
                      <div style="position:relative;top:0.02rem;right:0.06rem">{{val.name}}</div>
                    </el-badge>
                  </a>
                  <a v-else-if="val.url === '/cart'" :href="val.url" class="nav">
                    <img :src="val.img" alt="" class="mr-1">
                    <el-badge :value="$store.state.cartNum" class="item">
                      <div style="position:relative;top:0.02rem;right:0.06rem">{{val.name}}</div>
                    </el-badge>
                  </a>
                  <a v-else :href="val.url" class="nav">
                    <img :src="val.img" alt="" class="mr-1">
                    <div style="display:inline-block;position:relative;top:0.03rem">{{val.name }}</div>
                  </a>
                </template>
              </label>
              <!-- <div class="location" :class="{'isLogin': info.id}" @click="dialogVisible = true">
                <div class="location_img">
                  <img src="../assets/img/icon/location.png" alt="">
                </div>
                <div>
                  {{ currentSiteTxt }}
                </div>
                <div class="rightJT">
                  >
                </div>
              </div> -->
            </template>
            <template v-else>
              <div class="flex">
                <label for="" class="pl-3">
                  <div class="login" @click="$router.push('/login?type=login')">{{ $t("index.head.login")}}</div>
                </label>
                <label for="" class="pl-3">
                  <div class="nav" @click="$router.push('/login?type=register')">{{ $t("index.head.register") }}</div>
                </label>
              </div>
              <!-- <div class="location" :class="{'isLogin': info.id}" @click="dialogVisible = true">
                <div class="location_img">
                  <img src="../assets/img/icon/location.png" alt="">
                </div>
                <div>
                  {{ currentSiteTxt }}
                </div>
                <div class="rightJT">
                  >
                </div>
              </div> -->
            </template>
            <!-- <label for="" class="pl-3" v-for="(val,index) in navList" v-if="info.id" :key="index">
              <a :href="val.url" class="nav">
                <img :src="val.img" alt="" class="mr-1">
                {{val.name}}
              </a>
            </label> -->
          </div>
          
          
          <div class="flex language">
            <div 
              class="pl-3 pr-3 border-left" @click="handleToggleLanguage('CNT')">
              繁體中文
            </div>
            <div class="pl-3 pr-3 border-left"
              @click="handleToggleLanguage('CN')">
              简体中文
            </div>
            <div 
              class="pl-3 pr-3 border-left" @click="handleToggleLanguage('EN')">
              English
            </div>
            <div 
              class="pl-3 pr-3 border-left" @click="handleToOrder">
              {{ $t("index.info.guestOrder") }}
            </div>
          </div>
        </div>
      </el-col>
      <el-col>
        <div class="flex cursor">
          <router-link to="/home" tag="div" class="nav-item">{{ $t("index.tab.page") }}</router-link>
          <router-link to="/classify" tag="div" class="nav-item">{{ $t("index.tab.classification") }}</router-link>
          <router-link to="/news" tag="div" class="nav-item">{{ $t("index.tab.center") }}</router-link>
          <router-link to="/apply" tag="div" class="nav-item">{{ $t("index.tab.cooperation") }}</router-link>
          <router-link to="/about" tag="div" class="nav-item">{{ $t("index.tab.about") }}</router-link>
          <router-link to="/contact" tag="div" class="nav-item">{{ $t("index.tab.contact") }}</router-link>
          <!-- <div class="nav-item" :class="index === 1? 'border-b':''" @click="handleNav(1)">商城首頁</div>
          <div class="nav-item" :class="index === 2? 'border-b':''" @click="handleNav(2)">商城分類</div>
          <div class="nav-item" :class="index === 3? 'border-b':''" @click="handleNav(3)">新聞中心</div>
          <div class="nav-item" :class="index === 4? 'border-b':''" @click="handleNav(4)">加盟合作</div>
          <div class="nav-item" :class="index === 5? 'border-b':''" @click="handleNav(5)">關於我們</div>
          <div class="nav-item" :class="index === 6? 'border-b':''" @click="handleNav(6)">聯絡我們</div> -->
        </div>
      </el-col>
    </div>
    <el-dialog
      title="切換站點"
      :visible.sync="dialogVisible"
      class="dialogChange"
      width="30%">
      <div>
        <ul>
          <li
            v-for="item in siteList"
            :key="item.value"
            :class="{'active': item.value === currentSiteValue}"
            @click="siteListChange(item.value)"
          >
            {{ item.label }}
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">
          {{ $t("index.del.cancel") }}
        </el-button>
        <el-button type="primary" @click="dialogConfirm">
          {{ $t("index.del.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
  export default {
    name: "heade",
    data() {
      return {
        info:{},
        index:1,
        currentSiteTxt: '',
        currentSiteValue: '',
        currentSiteValueNow: '',
        dialogVisible: false,
        siteList: [],
        navList: [{
          name: this.$t("index.head.cart"),
          url: "/cart",
          img: require('@/assets/img/head/cart.png')
        }, {
          name: this.$t("index.head.msg"),
          url: "/message",
          img: require('@/assets/img/head/i-msg.png')
        }, 
        // {
        //   name: this.$t("index.head.list"),
        //   url: "#/order",
        //   img: require('@/assets/img/head/i-msg.png')
        // }, 
        {
          name: this.$t("index.head.mine"),
          url: "/info",
          img: require('@/assets/img/head/i-personal.png')
        },],
        language: ''
      };
    },
    created(){
      this.language = localStorage.getItem('language')
      localStorage.setItem('currentSiteValue', 4)
      let getItem = localStorage.getItem("TOKEN")||''
      this.currentSiteValueNow = localStorage.getItem('currentSiteValue') - 0
      console.log(this.currentSiteValueNow)
      console.log(localStorage.getItem('language'))
      if ((this.currentSiteValueNow === 2 || this.currentSiteValueNow === 3)) {
        if (localStorage.getItem('language') === 'EN' || localStorage.getItem('language') === 'CN') {
        } else {
          this.handleToggleLanguage('EN')
        }
      }
      if (this.currentSiteValueNow === 1 || this.currentSiteValueNow === 4) {
        if (localStorage.getItem('language') === 'EN' || localStorage.getItem('language') === 'CNT' || localStorage.getItem('language') === 'CN') {
        } else {
          this.handleToggleLanguage('CNT')
        }
      }
      // this.getCurrentSite('created')
      // this.getSiteList()
      if(getItem){
        this.userDetail()
      }
    },
    methods: {
      userDetail(){
        this.$http.post("/api/user/detail",{})
        .then(data=>{
          this.info = data
        })
      },
      getSiteList() {
        this.$http.get("/api/site-info/all-list")
        .then(res =>{
          // res = res.filter(v => v.label !== '新加坡')
          let language = localStorage.getItem("language")
          if (language === 'EN') {
            res.forEach(v => {
              v.label = v.titleEn
            })
          } else if (language === 'CNT'){
            res.forEach(v => {
              v.label = v.titleCnt
            })
          }
          this.siteList = res
        })
      },
      handleToOrder() {
        this.$router.push({ path: '/order?guest=guest' })
      },
      siteListChange(v) {
        this.currentSiteValue = v
      },
      getCurrentSite(str) {
        this.$http.get('/api/site-info/current-site').then(res => {
          // console.log(window.location.href)
          // console.log(str)
          // console.log(res.domain)
          // console.log(window.location.href.indexOf(res.domain))
          // if (str === 'created' && window.location.href.indexOf(res.domain) === -1) {
          //   setTimeout(() => {
          //     window.location.href = 'http://' + res.domain
          //   }, 100);
          //   return
          // }
          let language = localStorage.getItem("language")
          if (language === 'EN') {
            res.label = res.titleEn
          } else if (language === 'CNT'){
            res.label = res.titleCnt
          }
          this.currentSiteValue = res.value
          this.currentSiteTxt = res.label
          localStorage.setItem('currentSiteValue', res.value)
        })
      },
      dialogConfirm() {
        this.changeSite(this.currentSiteValue, true)
      },
      changeSite(id, flag) {
        // return this.$http.post('/api/site-info/change-site', {
        //   id
        // }).then(res => {
        //   console.log(id)
        //   localStorage.setItem('currentSiteValue', id)
        //   if (flag) {
        //     this.$$success(this.$t("index.address.editSuccess"))
        //     this.$router.replace('/')
        //     setTimeout(() => {
              
        //     },10)
        //     this.dialogVisible = false
        //   }
        // })
        // if (id === 3 || id === 4) {
        //   localStorage.setItem("language",'EN')
        // }
        window.location.href = `${window.location.protocol}//` + this.siteList[id-1].domain
      },
      handleToggleLanguage(val){
        localStorage.setItem("language",val)
        console.log(val)
        if(val == 'CNT'){
          localStorage.setItem("area",'HK')
        }else{
          localStorage.setItem("area",val)
        }
        location.reload()
      },
      handleNav(index){
        this.index = index
        if(index == 1){
          this.$router.push('/')
          return
        }
        if(index == 2){
          this.$router.push('/classify')
          return
        }
        // if(index == 3){
        //   this.$router.push('/news')
        //   return
        // }
        // if(index == 4){
        //   this.$router.push('/apply')
        //   return
        // }
        if(index == 5){
          this.$router.push('/about')
          return
        }
        if(index == 6){
          this.$router.push('/contact')
          return
        }
      }
    }
  };
</script>

<style scoped>
  .headImg{
width:38px;height:38px;border-radius:50%;border:1px solid #f2f2f2;
  }
  .border-line {
    height: 120px;
    border-bottom: 2px solid #f2f2f2;
  }
  .router-link-active{
    position: relative;
  }
  .router-link-active:after {
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -12px;
    top: 0;
    right: 0;
    width: 24px;
    height: 6px;
    background-color: #fe5b85;
    border-radius: 4px 4px 0px 0px;
  }
  .router-link-active:after {
    top: auto;
    bottom: 0;
  }
  .router-link-active {
    position: relative;
  }

  .border-t:before,
  .border-b:after {
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -12px;
    top: 0;
    right: 0;
    width: 24px;
    height: 6px;
    background-color: #fe5b85;
    border-radius: 4px 4px 0px 0px;
  }

  .border-b:after {
    top: auto;
    bottom: 0;
  }

  .login {
    padding: 7px 16px;
    background-color: #fe5b85;
    border-radius: 10px;
    font-size: 0.14rem;
    color: #ffffff;
    cursor: pointer;
  }

  .nav-item {
    font-size: 0.16rem;
    color: #414042;
    font-weight: bold;
    width: 172px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding-left: 30px; */
  }

  .language,
  .nav {
    font-size: 0.14rem;
    color: #414042;
    cursor: pointer;
  }

  .head {
    height: 126px;
  }

  .cursor div{
    cursor: pointer;
  }
  .location{
    /* margin-left: -900px; */
    margin-left: 0.6rem;
    display: flex;
    align-items: center;
    color: #FE5B85;
    cursor: pointer;
  }
  .location_img{
    width: 15px;
    height: 15px;
    padding-bottom: 3px;
    padding-right: 10px;
  }
  .location_img  img{
    width: 100%;
    height: 100%;
  }
  .rightJT{
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
  }
  .dialogChange{
    font-size: 0.14rem;
  }
  .dialogChange ul{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-left: 0;
  }
  .dialogChange ul li {
    border: #FE5B85 1px solid;
    border-radius: 16px;
    padding: 10px;
    width: 42%;
    margin-top: 10px;
    text-align: center;
    cursor: pointer;
  }
  .dialogChange ul li.active{
    color: #FE5B85;
  }
  .isLogin{
    /* position: relative;
    left: 11%;
    top: 0; */
  }
</style>


// WEBPACK FOOTER //
// src/components/head.vue